export default {"src":"/_next/static/media/PillCutoutWhite.6fd98a4d.svg","height":148,"width":264,"blurWidth":0,"blurHeight":0};